import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { GoogleMap, Marker } from "@react-google-maps/api";
// import { mapOptions } from "src/config/mapOptions";
import red_marker from "src/assets/images/red.png";
import { Button, CardContent, Grid, Tooltip, Typography } from "@mui/material";
import { IconArrowBack } from "@tabler/icons";
import BlankCard from "src/components/shared/BlankCard";
import vehicleProfileService from "src/service/vehicleProfile";
import moment from "moment";

const AlertMap = () => {
  const param = useParams();
  const navigate = useNavigate();
  const [SelectedAlertData, setSelectedAlertData] = useState({});

  const fetch_alert_Data = async () => {
    try {
      const res = await vehicleProfileService.getvehicleAlertdata({
        id: param.id,
      });

      setSelectedAlertData(res.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_alert_Data();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const parseLocation = (location) => {
    try {
      const parsedLocation = JSON.parse(location);
      return {
        lat: parseFloat(parsedLocation.lat),
        lng: parseFloat(parsedLocation.lng),
      };
    } catch (error) {
      console.error("Failed to parse location", error);
      return { lat: 0, lng: 0 };
    }
  };

  const coordinates = parseLocation(SelectedAlertData?.last_location || "{}");

  return (
    <>
      <Grid item sm={12} md={12} lg={12} xs={12} mb={2}>
        <BlankCard>
          <CardContent
            className="flex justify-between align-middle"
            style={{ backgroundColor: "#ECF2FF" }}
          >
            <div>
              <Typography variant="h5" style={{ fontFamily: "sans-serif" }}>
                Alert Details
              </Typography>
              <Typography mt={1} style={{ fontSize: "14px" }}>
                Vehicle &nbsp;&nbsp;&nbsp; ● &nbsp;&nbsp;&nbsp;
                {SelectedAlertData?.vehicle_no || "Vehicle Details"}{" "}
                &nbsp;&nbsp;&nbsp; | Alert Type &nbsp;&nbsp;&nbsp; ●
                &nbsp;&nbsp;&nbsp;
                {SelectedAlertData?.alert_name || "Vehicle Details"}
              </Typography>
              <Typography mt={1} style={{ fontSize: "14px" }}>
                Alert Time &nbsp;&nbsp;&nbsp; ● &nbsp;&nbsp;&nbsp;
                {SelectedAlertData?.last_date_time
                  ? moment(SelectedAlertData.last_date_time).format(
                      "DD-MM-YYYY hh:mm:ss a"
                    )
                  : "NA"}
              </Typography>
            </div>
            <div>
              <Tooltip title="Back">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  <IconArrowBack width={20} />
                </Button>
              </Tooltip>
            </div>
          </CardContent>
        </BlankCard>
      </Grid>
      <GoogleMap
        mapContainerStyle={{ height: "70vh", width: "100%" }}
        zoom={10}
        // options={mapOptions}
        center={coordinates}
      >
        <Marker
          position={coordinates}
          icon={{
            url: red_marker,
            scaledSize: new window.google.maps.Size(20, 20),
          }}
        />
      </GoogleMap>
    </>
  );
};

export default AlertMap;
